import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { Modal } from 'components/elements'
import AuthSteps from 'components/collections/AuthSteps'
import { useSession } from 'context/Session'

import * as S from './Welcome.styles'

const defaultProps = {}
const propTypes = {}

export const Welcome = () => {
  const router = useRouter()
  const [isOpen, setOpen] = useState(false)
  const { user } = useSession()

  return (
    <S.Wrapper>
      <S.Container>
        <S.Content>
          <S.Title>
            Bringing Clarity to the World of Biomedical Research
          </S.Title>
          <S.Desc>
            At TrialSite News, we cut through the noise to deliver transparent,
            independent reporting on biomedical and health research. Since 2018,
            we&apos;ve resisted both censorship and misinformation—choosing a
            third path grounded in critical thinking and evolving evidence.
            <br />
            <br />
            Our original content is backed by two proprietary tools: the
            TrialSite Evidence Strength Indicator™, rating studies from 0–10
            based on rigor and real-world relevance, and the TrialSite Bias
            Meter™, which flags bias across mainstream, trade, and alternative
            media. We&apos;re reader-supported and free from corporate
            influence. For just $5/month, you get unlimited access to objective,
            evidence-based analysis for patients, clinicians, researchers, and
            policymakers.
            <br />
            <br />
            <span style={{ fontStyle: 'italic' }}>
              Support integrity, clarity, and veracity in biomedical and
              health-related scientific communications.
            </span>
          </S.Desc>

          <S.GetStartedButton
            onClick={() => {
              if (!user) {
                setOpen(true)
              } else {
                router.push('/dashboard')
              }
            }}
          >
            Get Started
          </S.GetStartedButton>
          <Modal
            isOpen={isOpen}
            close={() => setOpen(false)}
            closeOnOutside={false}
          >
            <AuthSteps />
          </Modal>
        </S.Content>
      </S.Container>
    </S.Wrapper>
  )
}

Welcome.defaultProps = defaultProps
Welcome.propTypes = propTypes

export default Welcome
